import graph from "./graph";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { Box, Button, CircularProgress } from "@mui/material";
import { isEmptyObject } from "helpers/formatObject";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";

export default function AddToFavorits({ ids, isFavorite }) {
  const [checked, setChecked] = useState(Boolean(isFavorite));
  const { userToken } = useSelector((state) => state.auth);

  const [handleUpdate, { loading }] = useMutation(graph.update.query, {
    context: {
      serviceName: graph.update.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onChange = async () => {
    try {
      const { data, errors } = await handleUpdate({
        variables: {
          default_lab_items: [
            { lab_id: ids, status: !checked ? "ACTIVE" : "REJECTED" },
          ],
        },
      });
      if (!errors) {
        if (!isEmptyObject(data)) {
          const res = data[graph.update.name];
          res?.messages.map((message) => toast.success(String(message)));
          setChecked((prev) => !prev);
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Button
          size="medium"
          color="success"
          disabled={loading}
          sx={{ minWidth: 96 }}
          onClick={onChange}
          variant={checked ? "contained" : "outlined"}
          startIcon={
            checked ? (
              <StarRoundedIcon fontSize="small" />
            ) : (
              <StarOutlineRoundedIcon fontSize="small" />
            )
          }
        >
          {loading ? <CircularProgress size={20} /> : "منتخب"}
        </Button>
      </Box>
    </>
  );
}
